// +-------------------------------------------------------------
// | Created by WebStorm.
// +-------------------------------------------------------------
// | User: msmile
// +-------------------------------------------------------------
// | Date: 2025/4/11
// +-------------------------------------------------------------
// |Time: 16:51
// +-------------------------------------------------------------
import YmSearchSelect from '@/package/ym-search-select/Index.vue';
import YmDateTimeRange from '@/package/ym-date-time-range/Index.vue';
import YmTableColumnThumb from '@/package/ym-table-column-thumb/Index.vue';
const component = [YmSearchSelect,YmDateTimeRange,YmTableColumnThumb];
const install = (Vue) => {
    component.forEach((item) => {
        Vue.component(item.name, item);
    })
}
export default { install};